export enum UnitHistoryEventType {
  PRICE_CHANGE = 'price_change',
  STATUS_CHANGE = 'status_change',
  LISTING = 'listing',
  DELISTING = 'delisting',
  RESERVATION = 'reservation',
  SALE = 'sale'
}

export interface UnitHistoryEvent {
  id: number;
  eventDate: Date;
  eventType: UnitHistoryEventType;
  price?: number;
  sqmPrice?: number;
  priceChangeAmount?: number;
  priceChangePercentage?: number;
  status: string;
  previousStatus?: string;
  available: boolean;
  daysOnMarket?: number;
  source: string;
  notes?: string;
}

export interface PriceTrendData {
  date: Date;
  price: number;
  change: number;
  unitRef: string;
}

export interface MarketInsights {
  avgPrice: number;
  priceChanges: number;
  avgDaysOnMarket: number;
  totalUnits: number;
  soldUnits: number;
  availableUnits: number;
  conversionRate: number;
}

export interface ProjectPerformance {
  projectName: string;
  totalUnits: number;
  soldUnits: number;
  availableUnits: number;
  avgPrice: number;
  avgSqmPrice: number;
  avgDaysOnMarket: number;
  priceVolatility: number;
  conversionRate: number;
}
